/** Pure helpers for walk-in fee / discount preview. */

export function computeDiscPreview(feeNum, showDiscount, rawDisc, discKind, threshold) {
  if (!showDiscount || rawDisc <= 0) {
    return { pct: 0, amt: 0, final: feeNum, needsPin: false };
  }
  let amt; let pct;
  if (discKind === 'percent') {
    pct = Math.min(100, rawDisc);
    amt = Math.round((feeNum * pct) / 100 * 100) / 100;
  } else {
    amt = Math.min(feeNum, rawDisc);
    pct = feeNum > 0 ? Math.round((amt / feeNum * 100) * 100) / 100 : (amt > 0 ? 100 : 0);
  }
  const final = Math.max(0, Math.round((feeNum - amt) * 100) / 100);
  return { pct, amt, final, needsPin: pct > (threshold ?? 50) };
}

export function applyPatientToForm(p, setters) {
  setters.setPName(p.name || '');
  setters.setPAge(p.age != null ? String(p.age) : '');
  setters.setPGender((p.gender || 'male').toLowerCase());
  setters.setPEmail(p.email || '');
  if (p.phone) setters.setPPhone(p.phone);
  setters.setPRelationship(p.relationship || 'self');
  setters.setSelectedExisting(p);
  setters.setMode('pick');
  setters.setAutofillNote(
    p.patient_number
      ? `Loaded ${p.name} (${p.patient_number}) from records`
      : `Loaded ${p.name} from records`,
  );
}
